module.exports = __webpack_public_path__ + "1.4.15-unryo/img/solr.f453ed60.svg";